// frontend/src/utils/imageHelpers.js

export const getAvatarUrl = (avatarPath) => {
  if (!avatarPath) return null;
  
  // Handle if avatarPath is already a full URL
  if (avatarPath.startsWith('http://') || avatarPath.startsWith('https://')) {
    return avatarPath;
  }
  
  const baseUrl =
    process.env.REACT_APP_AVATAR_URL?.replace(/\/+$/, "") ||
    "http://localhost:8000/storage";
  const cleanPath = avatarPath.replace(/^\/+/, "");
  return `${baseUrl}/${cleanPath}`;
};


export const getAttachmentUrl = (attachment) => {
  if (!attachment) return null;
  const filePath = attachment.file_path || attachment.path || attachment.url || '';
  if (!filePath) return null;
  if (filePath.startsWith('http://') || filePath.startsWith('https://')) {
    return filePath;
  }
  const baseUrl = process.env.REACT_APP_API_URL?.replace(/\/+$/, '') || 'http://localhost:8000';
  const cleanPath = filePath.replace(/^\/+/, '');
  return `${baseUrl}/storage/${cleanPath}`;
};

export const formatTimeAgo = (dateStr) => {
  const now = new Date();
  const commentDate = new Date(dateStr);
  const diffSec = Math.floor((now - commentDate) / 1000);
  if (diffSec < 60) return "Just now";
  if (diffSec < 3600) return `${Math.floor(diffSec / 60)}m ago`;
  if (diffSec < 86400) return `${Math.floor(diffSec / 3600)}h ago`;
  return `${Math.floor(diffSec / 86400)}d ago`;
};

export const handlePasteImage = (event, taskId, setCommentFiles, toast) => {
  const items = event.clipboardData?.items;
  if (!items) return;
  const imageFiles = [];
  for (let i = 0; i < items.length; i++) {
    if (items[i].type.indexOf("image") !== -1) {
      const file = items[i].getAsFile();
      if (file) imageFiles.push(file);
    }
  }
  if (imageFiles.length > 0) {
    event.preventDefault();
    setCommentFiles((prev) => {
      const existingFiles = prev[taskId] || [];
      const existingArray = existingFiles instanceof FileList
        ? Array.from(existingFiles)
        : existingFiles;
      return {
        ...prev,
        [taskId]: [...existingArray, ...imageFiles],
      };
    });
    toast?.success(`📸 ${imageFiles.length} image(s) pasted`);
  }
};

// Image lazy loading utility
export const createImageWithLazyLoad = (src, callback) => {
  const img = new Image();
  img.onload = () => callback(null, img);
  img.onerror = () => callback(new Error('Failed to load image'), null);
  img.src = src;
};